import { render } from "./ResponsivePlayer.vue?vue&type=template&id=0921d12e&scoped=true"
import script from "./ResponsivePlayer.vue?vue&type=script&lang=js"
export * from "./ResponsivePlayer.vue?vue&type=script&lang=js"

import "./ResponsivePlayer.vue?vue&type=style&index=0&id=0921d12e&scoped=true&lang=css"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0921d12e"]])

export default __exports__